import React from "react";
import "./styles.scss";
import useApp from "../../hooks/useApp";

const IconText = ({ icon, text, className, iconLabelTextClass, link }) => {
  const { isRTL } = useApp();
  return (
    <div
      className={`text-container ${className}`}
      onClick={() =>
        link ? window.open(link, "_blank", "noopener,noreferrer") : null
      }
    >
      {icon && <img src={icon} alt="icon" className="icon" />}
      <span
        className={`icon-label-text ${iconLabelTextClass} ${
          link && "link-text"
        } ${isRTL ? "icon-label-text-rtl" : ""}`}
      >
        {text}
      </span>
    </div>
  );
};

export default IconText;
